"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const chat_1 = require("./chat");
const friends_1 = require("./friends");
const users_1 = require("./users");
const socket_io_client_1 = require("socket.io-client");
const friendRequests_1 = __importDefault(require("./friendRequests"));
class SocialAPI {
    socketUrl;
    chat;
    users;
    friends;
    friendRequests;
    constructor(baseUrl, socketUrl) {
        this.socketUrl = socketUrl;
        this.chat = new chat_1.ChatAPI(baseUrl);
        this.users = new users_1.UsersAPI(baseUrl);
        this.friends = new friends_1.FriendsAPI(baseUrl);
        this.friendRequests = new friendRequests_1.default(baseUrl);
    }
    createAuthenticatedSocket(authToken) {
        const socket = (0, socket_io_client_1.io)(this.socketUrl, {
            path: "/social/socket.io",
            withCredentials: true,
            transports: ["websocket"],
            auth: {
                token: authToken
            }
        });
        return socket;
    }
}
exports.default = SocialAPI;
//# sourceMappingURL=index.js.map